<template>
  <div>
    <!-- <div v-if="isMobile() === 'mobile-bg'">
      <router-view />
    </div> -->
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  name: "app",
  created() {
    // this.isMobile();
  },
  components: {},
  methods: {
    isMobile() {
      if (/Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.$router.push({ path: "/mobile" });
        return "mobile-bg";
      } else {
        return "web-bg";
      }
    }
  }
};
</script>

<style scope>
#app {
  font-family: "PingFang,PingFangSC-Light,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
